import { render, staticRenderFns } from "./viewEmail.vue?vue&type=template&id=53dc637f&"
import script from "./viewEmail.vue?vue&type=script&lang=js&"
export * from "./viewEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports